<ng-container *ngIf="sys === 'wt'">
    <figure class="inline-block relative bg-normal-2 circle margin-bottom-10 padding-15">
        <img loading= "lazy" [src]="cdnProducts + '/brand/wt/iso.png'" />
    </figure>
</ng-container>
<ng-container *ngIf="sys === 'ltk'">
    <figure class="inline-block relative bg-normal-2 circle margin-bottom-10 padding-15">
        <img loading= "lazy" [src]="cdnProducts + '/brand/ltk/crown.svg'" />
    </figure>
</ng-container>

